import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledAuthForm = styled.form`
    .login-desc-free {
        margin: 0;
        font-size: var(--size-24);
        font-weight: normal;
        line-height: 33px;
        color: var(--color-primary-fg);
        opacity: 0.8;
        @media ${breakpoints.sm} {
            font-size: var(--size-16);
        }
    }

    .btn-access-my-broker {
        margin-top: 4rem;
    }

    .itsMeLabel {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        margin-top: 24px;
        background: var(--color-grey-900);
        border: 1px solid var(--color-grey-900);
        border-radius: var(--radius-5);

        &:hover {
            background-color: var(--color-itsme-label-hover) !important;
        }
    }

    label {
        font-size: var(--size-16);
        line-height: 24px;
        color: var(--color-primary-fg);

        &.Mui-disabled {
            color: var(--color-primary-fg);
            opacity: 0.8;
        }
    }
`;
